import api from '@/services/utils/apiInstance.ts';

import type { FaqListResponse, FaqRequest, FaqResponse } from '@/types/services/faq/faq.type.ts';

class FaqService {
  async getAll(): Promise<FaqResponse[]> {
    const response = await api.get<FaqListResponse>('/faq/bo');
    return response.data.data;
  }

  async getById(faqId: number): Promise<FaqResponse> {
    const response = await api.get<FaqResponse>(`/faq/bo/${faqId}`);
    return response.data;
  }

  async create(faq: FaqRequest): Promise<FaqResponse> {
    const response = await api.post<FaqResponse>('/faq/bo', faq);
    return response.data;
  }

  async update(faqId: number, faq: FaqRequest): Promise<FaqResponse> {
    const response = await api.put<FaqResponse>(`/faq/bo/${faqId}`, faq);
    return response.data;
  }

  async setPublication(faqId: number, isPublished: boolean): Promise<FaqResponse> {
    const response = await api.patch<FaqResponse>(`/faq/bo/${faqId}/publication`, { isPublished });
    return response.data;
  }

  async reorder(ids: number[]): Promise<FaqResponse[]> {
    const response = await api.put<FaqListResponse>('/faq/bo/order', { ids });
    return response.data.data;
  }

  async remove(faqId: number): Promise<void> {
    await api.delete(`/faq/bo/${faqId}`);
  }
}

export default new FaqService();
